import TransactionList from "@/pages/Transaction/TransactionList.vue";

export default [
  {
    path: "/transactions",
    name: "Transaction",
    component: TransactionList,
    meta: { requiresAuth: true },
  },
];
